import apiAddress from "./apiAddress";

const imageBaseURL = `${apiAddress}/storage`;

const BASE = import.meta.env.BASE_URL.endsWith("/")
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;
const PLACEHOLDER = `${BASE}no-available.png`;

const isFalsyField = (v) =>
  v == null || v === "" || v === "null" || v === "undefined";

const isAbsoluteUrl = (s) =>
  typeof s === "string" && /^https?:\/\//i.test(s);

export const imgUrl = (field, fallback = PLACEHOLDER) => {
  if (isFalsyField(field)) return fallback;
  if (isAbsoluteUrl(field)) return field;
  return `${imageBaseURL}/${field}`;
};

export { PLACEHOLDER };

export default imageBaseURL;
